import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { localesShape } from '@spotahome/soyuz/shapes';
import { LanguageSwitcher as LanguageSwitcherComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/LanguageSwitcher.css';

import { updateURL } from '../utils/languageSwitcherUpdater';

import withAvailableLocales from './withAvailableLocales';

class LanguageSwitcher extends Component {
  static defaultProps = {
    abbreviated: false
  };

  static propTypes = {
    abbreviated: PropTypes.bool,
    current: PropTypes.string.isRequired,
    locales: PropTypes.shape(localesShape).isRequired,
    availableLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
    routing: PropTypes.shape({
      [PropTypes.string]: PropTypes.string
    }).isRequired
  };

  handleChange = selectedLocale => {
    updateURL(selectedLocale, this.props.routing);
  };

  render() {
    return (
      <LanguageSwitcherComponent
        current={this.props.locales.current}
        locales={this.props.availableLocales}
        abbreviated={this.props.abbreviated}
        onChange={this.handleChange}
        theme="light"
      />
    );
  }
}

export default withAvailableLocales()(LanguageSwitcher);
